import React, { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import {
	Button,
	Container,
	Alert,
	AppBar,
	Tab,
	Tabs,
	Box
} from '@mui/material';
import { Add } from '@mui/icons-material';

import { Subheader, TabPanel, Wip, StatusMessage } from 'components';
import EventList from 'features/events/EventList';
import PartnersList from 'features/partners/PartnersList';
import { useNavigation } from 'hooks';
import styled from 'styled-components';

const CREATE_BUTTON_CONFIG = [
	{
		url: 'events',
		title: 'Events'
	},
	{
		url: 'partners',
		title: 'Partners'
	}
];

const EventPartners = ({ ...props }) => {
	const navigate = useNavigate();
	const [tabValue, setTabValue] = useState(0);
	const [createConfig, setCreateConfig] = useState(CREATE_BUTTON_CONFIG[0]);
	const [wip, setWip] = React.useState(false);

	const handleTabChange = (_, newValue) => {
		setTabValue(newValue);
		setCreateConfig(CREATE_BUTTON_CONFIG[newValue]);
	};

	const { handleAddClick } = useNavigation({
		history,
		url: `/${createConfig.url}`
	});

	const createButton = useMemo(
		() => (
			<Button
				variant="contained"
				startIcon={<Add />}
				onClick={handleAddClick}
				color="primary"
			>
				{createConfig.title}
			</Button>
		),
		[createConfig.title]
	);

	if (wip) {
		return <Wip />;
	}

	return (
		<>
			<Subheader title="Events & Partners" buttons={[createButton]} />

			<div style={{ width: '100%' }}>
				<EventList title={'Events'} />
			</div>
		</>
	);
};

const StyledTabs = styled(Tabs)`
	width: 100%;
	margin: 0 1%;
`;
export default EventPartners;
